import { AccountsTreeModel } from '@miriamtech/if2-ui';
import { observable } from 'mobx';

export default class TreeModel extends AccountsTreeModel {
  @observable
  selectedAccount;
}
